export function arry2KeyValue(arr, suffix, exceptions) {
  if (!arr) {
    return [];
  }
  return arr.map(item => {
    if (exceptions && exceptions[item]) {
      return {
        ...exceptions[item]
      };
    }

    let label = item;
    if (suffix) {
      label = label + ' ' + suffix;
      if (item > 1) {
        label = label + 's';
      }
    }
    return {
      value: item,
      label
    };
  });
}
